import { render, staticRenderFns } from "./my_wallet.vue?vue&type=template&id=230fed00&scoped=true"
import script from "./my_wallet.vue?vue&type=script&lang=js"
export * from "./my_wallet.vue?vue&type=script&lang=js"
import style0 from "./my_wallet.vue?vue&type=style&index=0&id=230fed00&prod&lang=scss"
import style1 from "./my_wallet.vue?vue&type=style&index=1&id=230fed00&prod&lang=scss"
import style2 from "./my_wallet.vue?vue&type=style&index=2&id=230fed00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fed00",
  null
  
)

export default component.exports